import React from 'react';
import { Route } from 'react-router-dom';
import EditAgreement from 'modules/Agreements/EditAgreement/EditAgreement';
import Overview from 'modules/Overview/Overview';
import TagDetails from 'modules/TagDetails/TagDetails';
import { AGREEMENTS, EDIT_AGREEMENT, SUBSCRIPTION_PLAN_CHANGE, TAG_DETAILS } from 'routes/overview/paths';
import ChangeSubscriptionPlan from 'modules/ChangeSubscriptionPlan/ChangeSubscriptionPlan';
import RegisterVehicleRoutes from './RegisterVehicle';
import TerminateInactiveTagRoutes from './TerminateInactiveTag';
import TransferTagRoutes from './TransferTag';
import UnregisterVehicleRoutes from './UnregisterTag';
export default function OverviewRoutes() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: AGREEMENTS
  }, /*#__PURE__*/React.createElement(Overview, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: EDIT_AGREEMENT(':agreementId')
  }, /*#__PURE__*/React.createElement(EditAgreement, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: TAG_DETAILS(':tagNumber')
  }, /*#__PURE__*/React.createElement(TagDetails, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: SUBSCRIPTION_PLAN_CHANGE(':tagNumber')
  }, /*#__PURE__*/React.createElement(ChangeSubscriptionPlan, null)), /*#__PURE__*/React.createElement(RegisterVehicleRoutes, null), /*#__PURE__*/React.createElement(TransferTagRoutes, null), /*#__PURE__*/React.createElement(UnregisterVehicleRoutes, null), /*#__PURE__*/React.createElement(TerminateInactiveTagRoutes, null));
}